var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPencil = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17.499,
  height: 17.499,
  viewBox: "0 0 17.499 17.499"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "pencil",
  transform: "translate(-0.001)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1500",
  "data-name": "Group 1500",
  transform: "translate(0.001 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_583",
  "data-name": "Path 583",
  d: "M16.955,2.129,15.369.544a1.86,1.86,0,0,0-2.628,0l-11.8,11.8a.522.522,0,0,0-.142.269L.009,16.893a.513.513,0,0,0,.6.6L4.888,16.7a.522.522,0,0,0,.269-.142l11.8-11.8A1.857,1.857,0,0,0,16.955,2.129ZM1.153,16.347l.48-2.59,2.11,2.11Zm3.642-.878L2.031,12.7,12.12,2.614l2.764,2.764ZM16.23,4.032l-.621.621L12.845,1.889l.621-.621a.834.834,0,0,1,1.178,0L16.23,2.854A.832.832,0,0,1,16.23,4.032Z",
  transform: "translate(0 0)",
  fill: "#7b7b7b"
})))));
export { SvgPencil as ReactComponent };
export default __webpack_public_path__ + "static/media/pencil.5a90d7169664b6eb57d7f179958c53de.svg";